import React from 'react';
import { Building2, FileText, CalendarClock } from 'lucide-react';
import { formatDeadline, formatCurrency } from '../utils/helperUtils';
import aedLogo from '../../../../../assets/images/aedcurrency.jpg';

/**
 * InfoCardsRow — extracted from RFPAnalysisResult.jsx (Phase 6 refactor).
 * Renders the 4 KPI summary cards: Client, Project, Deadline, Budget.
 * Only shown when activeStep <= 3.
 * Zero logic changes. All data passed as props from parent.
 */
const InfoCardsRow = ({ activeStep, editableData, isManager }) => {

    if (!isManager) return null; // Role protection: Editor sees info in the main header beside the back button

    return (
        <div className="info-cards-row">
            <div className="info-card">
                <div className="info-card-top">
                    <div className="info-card-icon client-icon"><Building2 size={14} /></div>
                    <span className="info-card-label">CLIENT</span>
                </div>
                <span className="info-card-title">{editableData.CLIENT_NAME || 'N/A'}</span>
                <span className="info-card-sub">{editableData.CLIENT_LOCATION || '—'}</span>
            </div>
            <div className="info-card">
                <div className="info-card-top">
                    <div className="info-card-icon project-icon"><FileText size={14} /></div>
                    <span className="info-card-label">PROJECT</span>
                </div>
                <span className="info-card-title">{editableData.PROPOSAL_TITLE || 'N/A'}</span>
                <span className="info-card-sub">{editableData.INDUSTRY || '—'}</span>
            </div>
            <div className="info-card">
                <div className="info-card-top">
                    <div className="info-card-icon deadline-icon"><CalendarClock size={14} /></div>
                    <span className="info-card-label">PROPOSAL DEADLINE</span>
                </div>
                <span className="info-card-title">{formatDeadline(editableData.PROPOSAL_DEADLINE || editableData.proposal_deadline || '')}</span>
                <span className="info-card-sub">Current Deadline</span>
            </div>
            <div className="info-card">
                <div className="info-card-top">
                    <div className="info-card-icon budget-icon" style={{ padding: 0, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img src={aedLogo} alt="AED" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }} />
                    </div>
                    <span className="info-card-label">ESTIMATED BUDGET</span>
                </div>
                <span className="info-card-title">{formatCurrency(editableData.VALUATION || editableData.valuation, editableData.CURRENCY || editableData.currency)}</span>
                <span className="info-card-sub">Approximate Value</span>
            </div>
        </div>
    );
};

export default InfoCardsRow;
